import angular from 'angular';

const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['object', '$uibModalInstance', 'AncillariesConstants', '$window', '$filter', '$rootScope'],
    required: []
};


export class IbModalSelectSeat implements angular.IController {

    public model: any;
    iconClass: string = '';
    showUnselectButton: boolean = false;

    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private AncillariesConstants: AncillariesConstant,
        private $window: ng.IWindowService,
        private $filter: ng.FilterFactory,
        private $rootScope: CommonsRootScope) {
        this.model = object;
    }
    $onInit (): void {
        this.setIconClass();
        this.setPriceText();
        this.initUnselectButton();
    }

    $onDestroy (): void {
        this.$window.SeatMapVr.destroy();
    }

    private initUnselectButton (): void {
        this.showUnselectButton = this.model.seat.selectable && this.model.seatOccupation === 'SELECTION' && this.$rootScope.flowName !== this.AncillariesConstants.APPLICATION_FLOW.CHECKIN && this.model.currentPassenger.seatPrice !== 0;
    }

    private setIconClass (): void {
        if(!this.model.isOldConfig) {
            switch(this.model.seat.seatType) {
                    case this.AncillariesConstants.SeatFeatures.extraSize:
                        this.iconClass = 'xl';
                        break;
                    case this.AncillariesConstants.SeatFeatures.emergencyExit:
                        this.iconClass = 'emergency';
                        break;
                    case this.AncillariesConstants.SeatFeatures.infant:
                        this.iconClass = 'baby';
                        break;
                    case this.AncillariesConstants.SeatFeatures.mobility:
                        this.iconClass = 'redux';
                        break;
                    case this.AncillariesConstants.SeatFeatures.upfront:
                    case this.AncillariesConstants.SeatFeatures.promo:
                    default:
                        this.iconClass = 'standard';
                        break;
            }
        } else {
            switch(this.model.seat.seatType) {
                    case this.AncillariesConstants.SeatFeatures.extraSize:
                        this.iconClass = 'xl';
                        break;
                    case this.AncillariesConstants.SeatFeatures.upfront:
                        this.iconClass = 'upfront';
                        break;
                    case this.AncillariesConstants.SeatFeatures.emergencyExit:
                        this.iconClass = 'emergency';
                        break;
                    case this.AncillariesConstants.SeatFeatures.infant:
                        this.iconClass = 'infant';
                        break;
                    case this.AncillariesConstants.SeatFeatures.promo:
                        this.iconClass = 'promo';
                        break;
                    case this.AncillariesConstants.SeatFeatures.mobility:
                        this.iconClass = 'handicap';
                        break;
                    default:
                        this.iconClass = 'standard';
                        break;
            }
        }
    }


    private setPriceText (): void {
        let priceText: string = this.model.seat.price;
        if((this.model.currentPassenger.freeSeat && this.isSelectedSeat(this.model.currentPassenger.freeSeat, this.model.seat))
            || (this.model.currentPassenger.issuedSeat && this.isSelectedSeat(this.model.currentPassenger.issuedSeat, this.model.seat))) {
            priceText = this.model.currentPassenger.seatPriceFormatted;
        }
        this.model.seat.priceText =
            this.$filter('translate')('NEW_SEATS_MAP_PRICE')
                .replace('#', priceText);
    }

    private isSelectedSeat (issuedSeat: any, selectedSeat: any): boolean {

        return issuedSeat.row === selectedSeat.row
            && issuedSeat.column === selectedSeat.column;
    }


    openSeat3d (): void {
        if (this.model.seatViewInfo) {
            this.$window.SeatMapVr.selectScene({
                layout: this.model.seatViewInfo.layout,
                scene: this.model.seat.row + this.model.seat.column,
                flight: this.model.seatViewInfo.flight,
                seat: this.model.seatViewInfo.seat,
                passenger: {displayName: this.model.currentPassenger.name},
                screenMode: this.$window.SeatMapVr.SCREEN_MODE ? this.$window.SeatMapVr.SCREEN_MODE.MODAL : 1
            });
        }
    }



    selectSeat (): void {
        this.$uibModalInstance.close(true);
    }

    unselectSeat (): void {
        this.$uibModalInstance.close(false);
    }

    dismissModal (): void {
        this.$uibModalInstance.dismiss();
    }



}

try {
    IbModalSelectSeat.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(IbModalSelectSeat.name, IbModalSelectSeat);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    IbModalSelectSeat.$inject = controllerInfo.inject;
    mod.controller(IbModalSelectSeat.name, IbModalSelectSeat);
}